import {
  ID,
  JOB_STATUS_NAMES,
  JobBase,
  JobStatus,
  Work,
} from "@project/shared-types";
import { ColDef } from "ag-grid-community";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "../../../components/button/button";
import { Loader } from "../../../components/Loader/Loader";
import { Text } from "../../../components/texts/text";
import Title from "../../../components/texts/title";
import { _sizeHeading, _sizeText, _style } from "../../../core/core";
import { unsetExecutorJob } from "../AdminAPI";
import { ItemBasePage } from "../pages/ItemBasePage";
import { jobsProvider, worksProvider } from "../provders";
import { GridData } from "./GridData";
import "./PreviewObject.css";

export const PreviewJob = () => {
  const { id } = useParams();
  const [executorWorks, setExecutorWorks] = useState<Work[]>([]);
  const [isCreateBan, setIsCreateBan] = useState(false);
  const [job, setJob] = useState<JobBase | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [updateAlert, setUpdateAlert] = useState<Boolean>(false);

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      worksProvider
        .getList<Work>({
          filters: [{ field: "job_id", operator: "eq", value: id }],
        })
        .then((works) => {
          setExecutorWorks(works.data);
        })
        .finally(() => {
          setIsLoading(false);
        });
      jobsProvider
        .getOne<JobBase>(id)
        .then((job) => {
          setJob(job);
        })
        .finally(() => {
          setIsLoading(false);
        });

      setUpdateAlert(false);
    }
  }, [id, updateAlert]);
  const [columnDefsWorks] = useState<ColDef<Work>[]>([
    { field: "id", headerName: "ID", sortable: true, filter: true },
    { field: "job_id", headerName: "ID задания", sortable: true, filter: true },
    { field: "nickname", headerName: "Ник", sortable: true, filter: true },
    { field: "text", headerName: "Текст", sortable: true, filter: true },
    {
      field: "date_published",
      headerName: "Дата начала",
      sortable: true,
      filter: true,
    },
    { field: "status", headerName: "Статус", sortable: true, filter: true },
  ]);

  const handleUnsetJob = () => {
    if (job?.id) {
      unsetExecutorJob(job.id);
      setUpdateAlert(true);
    }
  };
  return (
    <div className="preview-executor">
      {job ? (
        <>
          <div className="preview-executor-body">
            <ItemBasePage<JobBase>
              id={job.id}
              title={`Задание ${job.view_id}`}
              data={job}
              fieldConfig={{
                id: {
                  label: "ID",
                  valueMapper: (value: ID) => value.toString(),
                },
                executor_id: {
                  label: "Исполнитель",
                  valueMapper: (value: ID | null) =>
                    value ? value.toString() : "Не назначен",
                },
                status: {
                  label: "Статус",
                  valueMapper: (value: JobStatus) => JOB_STATUS_NAMES[value],
                },
                properties: {
                  label: "Свойства",
                  valueMapper: (value: any) =>
                    JSON.stringify(value, null, 2).replace(/\n/g, "\n"),
                },
                date_public: {
                  label: "Дата публикации",
                  valueMapper: (value: number) =>
                    new Date(value).toLocaleString(),
                },
              }}
            />
            <div className="preview-object-column">
              <Button
                style={_style.outline}
                onClick={() => setIsCreateBan(true)}
              >
                Заблокировать
              </Button>
              <Button style={_style.outline}>Отправить сообщение</Button>
            </div>
          </div>
          <div className="preview-executor-tickets">
            <div className="preview-executor-title">
              <Title type={_sizeHeading.h3}>Попытки</Title>
              <div className="preview-object-row">
                <Button onClick={handleUnsetJob} style={_style.outline}>
                  Снять
                </Button>
                <Button style={_style.outline}>Подробнее</Button>
              </div>
            </div>
            {executorWorks.length > 0 ? (
              <GridData<Work>
                rowData={executorWorks}
                columnDefs={columnDefsWorks}
              ></GridData>
            ) : (
              <Text size={_sizeText.m}>Попыток нет</Text>
            )}
          </div>
        </>
      ) : (
        <Loader isLoading={isLoading}></Loader>
      )}
    </div>
  );
};
